import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { trackLastVisited } from "../utils/RedirectUtility";

/**
 * Saves every route a logged-in person visits as their last_visited_url.
 */
const RouteTracker: React.FC = () => {
  const location = useLocation();
  const auth = useSelector((state: any) => state.reducer.auth);
  const personId = auth && auth.isLoggedIn && auth.user && auth.user._id ? auth.user._id : '';

  useEffect(() => {
    if (personId) {
      trackLastVisited(personId, location.pathname + location.search);
    }
  }, [personId, location.pathname, location.search]);

  return null;
};

export default RouteTracker;
